(function() {
  var styleId = 'billion-header-search-fix-style';
  var cache = {};
  var rendering = false;

  function injectStyles() {
    if (document.getElementById(styleId)) return;

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = '' +
      '.billion-header-search__form,.billion-mobile-search__form{position:relative;overflow:hidden;box-shadow:none!important;}' +
      '.billion-header-search__input,.billion-mobile-search__input{appearance:none;-webkit-appearance:none;background:transparent!important;border:0!important;box-shadow:none!important;outline:0!important;height:auto!important;min-height:0!important;width:100%!important;min-width:0!important;padding:0!important;margin:0!important;color:#111827;font-size:13px;line-height:1.3;}' +
      '.billion-header-search__input:focus,.billion-mobile-search__input:focus{background:transparent!important;border:0!important;box-shadow:none!important;outline:0!important;}' +
      '.billion-header-search__input::-webkit-search-decoration,.billion-header-search__input::-webkit-search-cancel-button,.billion-mobile-search__input::-webkit-search-decoration,.billion-mobile-search__input::-webkit-search-cancel-button{-webkit-appearance:none;appearance:none;}' +
      '.billion-header-search__input::placeholder,.billion-mobile-search__input::placeholder{color:#8a94a3;font-style:italic;}' +
      '.billion-search-results{display:none;position:absolute;top:calc(100% + 8px);left:0;right:0;z-index:400;background:#fff;border:1px solid #e5e7eb;border-radius:8px;box-shadow:0 14px 34px rgba(15,23,42,.16);overflow:hidden;padding:4px 0;}' +
      '.billion-search-results.is-open{display:block;}' +
      '.billion-search-results a{display:grid;grid-template-columns:42px minmax(0,1fr) auto;align-items:center;gap:10px;min-height:56px;padding:7px 12px;color:#111827;text-decoration:none;border-bottom:1px solid #eef2f6;background:#fff;}' +
      '.billion-search-results a:hover{background:#f8fafc;}' +
      '.billion-search-results a:last-child{border-bottom:0;}' +
      '.billion-search-results__thumb{width:42px;height:42px;border-radius:4px;object-fit:cover;background:#f3f4f6;display:block;}' +
      '.billion-search-results__content{min-width:0;}' +
      '.billion-search-results__title{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;margin:0;color:#374151;font-size:12px;font-weight:500;line-height:1.25;letter-spacing:0;}' +
      '.billion-search-results__price{white-space:nowrap;color:#111827;font-size:12px;font-weight:800;line-height:1.2;}' +
      '.billion-search-results__query,.billion-search-results__empty{display:block;padding:10px 13px;color:#667085;font-size:12px;line-height:1.3;}' +
      '.billion-search-results__view-all{grid-template-columns:1fr!important;min-height:40px!important;padding:11px 13px!important;font-weight:800;font-size:13px;}' +
      '.billion-mobile-search{z-index:500!important;}' +
      '.billion-mobile-search__results{position:static!important;margin:8px 0 0;box-shadow:none;border-radius:8px;}' +
      '@media(max-width:749px){.billion-header-search .billion-search-results{left:0;right:0}.billion-search-results a{grid-template-columns:44px minmax(0,1fr) auto;min-height:58px}.billion-search-results__thumb{width:44px;height:44px}}';

    document.head.appendChild(style);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character];
    });
  }

  function money(value) {
    if (value === null || typeof value === 'undefined' || value === '') return '';
    if (typeof value === 'string' && /R\$|\$|,/.test(value)) return value;
    var numeric = Number(value);
    if (Number.isNaN(numeric)) return String(value);
    return numeric.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function imageUrl(product) {
    if (!product) return '';
    if (product.featured_image) {
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (product.featured_image.url) return product.featured_image.url;
      if (product.featured_image.src) return product.featured_image.src;
    }
    if (product.image) {
      if (typeof product.image === 'string') return product.image;
      if (product.image.url) return product.image.url;
      if (product.image.src) return product.image.src;
    }
    if (product.featured_media && product.featured_media.preview_image) {
      return product.featured_media.preview_image.url || product.featured_media.preview_image.src || '';
    }
    return '';
  }

  function render(target, data, query) {
    if (!target) return;
    var products = data && data.resources && data.resources.results && data.resources.results.products || [];
    var queries = data && data.resources && data.resources.results && data.resources.results.queries || [];
    var html = '';

    if (!products.length && !queries.length) {
      target.innerHTML = '<div class="billion-search-results__empty">Nenhum resultado para <strong>' + escapeHtml(query) + '</strong></div>';
      target.classList.add('is-open');
      return;
    }

    queries.slice(0, 2).forEach(function(item) {
      var term = item.title || item.text || '';
      html += '<a class="billion-search-results__query" href="/search?q=' + encodeURIComponent(term) + '&type=product">' + escapeHtml(term) + '</a>';
    });

    products.slice(0, 5).forEach(function(product) {
      var src = imageUrl(product);
      var price = product.price_min || product.price || product.compare_at_price || '';
      html += '<a class="billion-search-results__product" href="' + escapeHtml(product.url || '#') + '">';
      if (src) {
        html += '<img class="billion-search-results__thumb" src="' + escapeHtml(src) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">';
      } else {
        html += '<span class="billion-search-results__thumb" aria-hidden="true"></span>';
      }
      html += '<span class="billion-search-results__content"><span class="billion-search-results__title">' + escapeHtml(product.title) + '</span></span>';
      html += '<strong class="billion-search-results__price">' + escapeHtml(money(price)) + '</strong>';
      html += '</a>';
    });

    html += '<a class="billion-search-results__view-all" href="/search?q=' + encodeURIComponent(query) + '&type=product">Ver todos os resultados</a>';
    rendering = true;
    target.innerHTML = html;
    target.classList.add('is-open');
    window.setTimeout(function() { rendering = false; }, 0);
  }

  function fetchAndRender(input, target) {
    var query = input && input.value ? input.value.trim() : '';
    if (!query || query.length < 2) return;

    if (cache[query]) {
      render(target, cache[query], query);
      return;
    }

    fetch('/search/suggest.json?resources[type]=product,query&resources[limit]=6&q=' + encodeURIComponent(query))
      .then(function(response) { return response.json(); })
      .then(function(data) {
        cache[query] = data;
        render(target, data, query);
      })
      .catch(function() {});
  }

  function bind(input, target) {
    if (!input || !target || input.dataset.billionSearchFixed === 'true') return;
    input.dataset.billionSearchFixed = 'true';

    var timer;
    input.addEventListener('input', function() {
      clearTimeout(timer);
      timer = window.setTimeout(function() { fetchAndRender(input, target); }, 260);
    });
    input.addEventListener('focus', function() {
      window.setTimeout(function() { fetchAndRender(input, target); }, 80);
    });

    new MutationObserver(function() {
      if (rendering) return;
      if (input.value.trim().length >= 2 && target.classList.contains('is-open') && !target.querySelector('.billion-search-results__product')) {
        window.setTimeout(function() { fetchAndRender(input, target); }, 40);
      }
    }).observe(target, { childList: true, subtree: true });
  }

  function init() {
    injectStyles();
    bind(document.querySelector('[data-billing-search-input]'), document.querySelector('[data-billing-search-results]'));
    bind(document.querySelector('[data-billing-mobile-search-input]'), document.querySelector('[data-billing-mobile-search-results]'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

(function() {
  var observerStarted = false;
  var applyTimer = 0;
  var offerStyleId = 'billion-offer-badge-style';
  var translations = {
    'Availability': 'Disponibilidade',
    'Price': 'Preço',
    'Filter': 'Filtrar',
    'Filters': 'Filtros',
    'Filter and sort': 'Filtrar e organizar',
    'Sort': 'Organizar',
    'Sort by': 'Ordenar por',
    'Sort by:': 'Ordenar por:',
    'Alphabetically, A-Z': 'Ordem alfabética, A-Z',
    'Alphabetically, Z-A': 'Ordem alfabética, Z-A',
    'Price, low to high': 'Preço, menor para maior',
    'Price, high to low': 'Preço, maior para menor',
    'Date, old to new': 'Data, antigo para novo',
    'Date, new to old': 'Data, novo para antigo',
    'Best selling': 'Mais vendidos',
    'Featured': 'Destaques',
    'Relevance': 'Relevância',
    'Newest': 'Mais recentes',
    'Oldest': 'Mais antigos'
  };

  function injectOfferBadgeStyles() {
    if (document.getElementById(offerStyleId)) return;
    var style = document.createElement('style');
    style.id = offerStyleId;
    style.textContent = '' +
      '.billion-offer-badge{align-items:center!important;background:#111827!important;background:rgb(var(--color-base-accent-1))!important;border:0!important;border-radius:7px!important;box-shadow:0 4px 12px rgba(0,0,0,.18)!important;color:#fff!important;color:rgb(var(--color-base-solid-button-labels))!important;display:inline-flex!important;font-size:12px!important;font-weight:800!important;gap:0!important;justify-content:center!important;letter-spacing:0!important;line-height:1!important;min-height:26px!important;min-width:auto!important;overflow:hidden!important;padding:0 9px!important;pointer-events:none!important;text-transform:none!important;width:auto!important;}' +
      '.billion-offer-badge svg,.billion-offer-badge .icon{display:none!important;}' +
      '.billion-offer-badge__label{align-items:center;display:inline-flex;min-height:26px;}' +
      '.billion-media-sale-badge .billion-media-sale-badge__label{text-transform:none!important;}';
    document.head.appendChild(style);
  }

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function translate(value) {
    var text = normalize(value);
    return translations[text] || translations[text.replace(/:$/, '')] || text;
  }

  function textLooksLikeSaleBadge(text) {
    var value = normalize(text).toUpperCase();
    return value.indexOf('%') !== -1 || value.indexOf('SAVE') !== -1 || value.indexOf('SALE') !== -1 || value.indexOf('OFF') !== -1 || value.indexOf('DESCONTO') !== -1 || value.indexOf('PROMO') !== -1 || value === 'OFERTA';
  }

  function replaceTextNodeWords(element) {
    if (!element) return;
    Array.prototype.forEach.call(element.childNodes, function(node) {
      if (node.nodeType !== Node.TEXT_NODE) return;
      var updated = node.nodeValue
        .replace(/\bAvailability\b/g, 'Disponibilidade')
        .replace(/\bPrice\b/g, 'Preço')
        .replace(/\bFilter and sort\b/g, 'Filtrar e organizar')
        .replace(/\bFilter\b/g, 'Filtrar')
        .replace(/\bSort by\b/g, 'Ordenar por');
      if (updated !== node.nodeValue) node.nodeValue = updated;
    });
  }

  function normalizeSaleBadges(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.billion-media-sale-badge'), function(badge) {
      if (normalize(badge.textContent) !== 'OFERTA') {
        badge.innerHTML = '<span class="billion-media-sale-badge__label">OFERTA</span>';
      }
    });

    Array.prototype.forEach.call(root.querySelectorAll('.badge, .card__badge, [class*="badge"]'), function(badge) {
      if (!textLooksLikeSaleBadge(badge.textContent)) return;
      if (badge.closest('.billion-media-sale-badge')) return;
      badge.classList.add('billion-offer-badge');
      badge.innerHTML = '<span class="billion-offer-badge__label">OFERTA</span>';
      badge.setAttribute('aria-label', 'Oferta');
    });
  }

  function translateCollectionControls(root) {
    Array.prototype.forEach.call(root.querySelectorAll('summary, button, label, .facets__summary, .mobile-facets__summary, .mobile-facets__close-button, .facet-filters__label, .active-facets__button-inner'), function(element) {
      replaceTextNodeWords(element);
      Array.prototype.forEach.call(element.querySelectorAll('span'), function(span) {
        var translated = translate(span.textContent);
        if (translated && translated !== normalize(span.textContent)) span.textContent = translated;
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('select[name="sort_by"] option, select[id*="SortBy"] option'), function(option) {
      var translated = translate(option.textContent);
      if (translated && translated !== normalize(option.textContent)) option.textContent = translated;
    });
  }

  function applyFixes(root) {
    root = root || document;
    injectOfferBadgeStyles();
    normalizeSaleBadges(root);
    translateCollectionControls(root);
  }

  function scheduleApply() {
    window.clearTimeout(applyTimer);
    applyTimer = window.setTimeout(function() { applyFixes(document); }, 60);
  }

  function init() {
    applyFixes(document);
    if (observerStarted) return;
    observerStarted = true;
    new MutationObserver(scheduleApply).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', scheduleApply);
})();
